
import axios from 'axios'
import html2canvas from 'html2canvas'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import QRCode from 'qrcodejs2';

export default {
name: 'demo',
components: {XHeader, XButton,Toast,XDialog,Popup, XSwitch},
data () {
return {
show13: '',
imgUrl: '',
school: '',
graduate: '',
name: '',
education: '',
major: '',
stuReason: '',
date: '',

Pwidth: {},
isShow: true,
TuZhang: '',
isLoad:false,
z: require('../assets/zhang.png'),
htmlTitle: '解约函',
mobile:'',
isflow:''
}
},
mounted () {

if (sessionStorage.getItem('mobile') === null) {
this.$router.push({path: '/FindDetail'})
}
console.log(document.body.scrollHeight)
this.isflow = document.body.scrollHeight > 675 ? 'height:100%' : '';
this.creatQrCode()
this.findMessage()
},
methods: {
clickGeneratePicture: function () { // 生成图片
window.pageYOffset = 0;
document.documentElement.scrollTop = 0
document.body.scrollTop = 0
this.Pwidth = {
'width': this.$refs.imageDom.clientWidth,
'height': this.$refs.imageDom.clientHeight
}
console.log(this.$refs.imageDom.clientWidth)
console.log(this.$refs.imageDom.clientHeight)
html2canvas(this.$refs.imageDom, {
width:this.$refs.imageDom.clientWidth ,
height:this.$refs.imageDom.clientHeight,
scrollY: 0,
scrollX: 0,
useCORS: true,
scale: 5
}).then(canvas => {

this.imgUrl = canvas.toDataURL('image/png',1.0) 


this.isShow = false
})
},


creatQrCode() {
let url = 'http://student.hmifo.com/#/QRCode?mobile=' + sessionStorage.getItem('mobile')
let qrcode = new QRCode(this.$refs.qrCodeUrl, {
text: url, // 需要转换为二维码的内容
width: 300,
height: 300,
colorDark: '#000000',
colorLight: '#ffffff',
correctLevel: QRCode.CorrectLevel.H
})
this.$refs.qrCodeUrl.childNodes[1].style.width = '100%'
this.$refs.qrCodeUrl.childNodes[1].style.height = '100%'
this.$refs.qrCodeUrl.childNodes[0].style.width = '100%'
this.$refs.qrCodeUrl.childNodes[0].style.height = '100%'
},

downloadIamge: function () {
let image = new Image()

image.setAttribute('crossOrigin', 'anonymous')
let that = this
image.onload = function () {
let canvas = document.createElement('canvas')
canvas.width = image.width
canvas.height = image.height
let context = canvas.getContext('2d')
context.drawImage(image, 0, 0, image.width, image.height)
let url = canvas.toDataURL('image/png') 
let a = document.createElement('a') 
let event = new MouseEvent('click') 
a.download = '' 
a.href = url 
a.dispatchEvent(event) 
}
image.src = that.imgUrl
},

findMessage: function () {
this.mobile = this.$route.params.mobile
if (this.mobile == null) {
this.mobile = sessionStorage.getItem('mobile')
}

let param = new URLSearchParams()
param.append('mobile', this.mobile)
axios.post('http://student.hmifo.com/admin/application/permission', param).then((r) => {
console.log(r)
if (r.data.code === 200) {
if (r.data.term !== null) {
this.school = r.data.term.school
this.graduate = r.data.term.graduate
this.name = r.data.term.name
this.education = r.data.term.education
this.major = r.data.term.major
this.stuReason = r.data.term.stuReason
this.date = r.data.term.perTime.substring(0, 4) + '年' + r.data.term.perTime.substring(5, 7) + '月' + r.data.term.perTime.substring(8, 10) + '日'
console.log(this.date)
} else {
this.$vux.toast.text('数据查询失败！')
}
} else {
this.$vux.toast.text('接口调用失败')
}
}).then(() => {
this.clickGeneratePicture()
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/demo.vue